// Apresentação apenas: preserva datas já formatadas pela API, sem mudar o pedido.
export default function pedidoDataExibicao(value) {
  if (value == null) return '-';
  const text = String(value).trim();
  if (!text || /^(invalid date|null|undefined|nan)$/i.test(text)
      || /^0000-00-00(?:[ T]|$)/.test(text)) return '-';
  return value;
}